// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, Input } from '@angular/core';
import { ButtonAligns } from '../button.model';

@Component({
  selector: 'e-buttons',
  templateUrl: './buttons.component.html',
  styleUrls: ['./buttons.component.scss'],
})
export class ButtonsComponent {
  @Input() align : ButtonAligns | string = ButtonAligns.None;
}
